import React from 'react';
import { withRouter } from 'react-router-dom';

import './Workspace.css';
import TabBar from './TabBar';
import WorkspaceContent from './WorkspaceContent';
import AuthContext from '../context/AuthContext';

class Workspace extends React.Component {
  static contextType = AuthContext;

  state = {
    launcherOpen: false,
    openTabs: [],
    unlisten: null,
  };

  componentDidMount() {
    const { availableTabs } = this.context;
    const { history } = this.props;
    const { pathname } = history.location;
    for (let tab of availableTabs) {
      if (pathname.startsWith(tab.url)) {
        this.handleLaunch(tab, pathname);
      }
    }
    const unlisten = history.listen(this.handleHistoryChange);
    this.setState((state) => ({...state, unlisten}));
  }

  componentWillUnmount() {
    const { unlisten } = this.state;
    if (unlisten !== null) {
      unlisten();
      this.setState((state) => ({...state, unlisten: null}));
    }
  }

  render() {
    const { availableTabs } = this.context;
    const { launcherOpen, openTabs } = this.state;
    return (
      <div className="ds__Workspace">
        <div className="ds__Workspace__header">
          <TabBar
            availableTabs={availableTabs}
            launcherOpen={launcherOpen}
            openTabs={openTabs}
            onCloseTab={this.handleCloseTab}
            onCloseLauncher={this.handleCloseLauncher}
            onLaunch={this.handleLaunch}
            onToggleLauncher={this.handleToggleLauncher}
          />
        </div>
        <div className="ds__Workspace__content">
          <WorkspaceContent tabs={openTabs} />
        </div>
      </div>
    );
  }

  handleHistoryChange = (e) => {
    const { availableTabs } = this.context;
    const tab = availableTabs.find((t) => e.pathname.startsWith(t.url));
    if (tab) {
      this.handleLaunch(tab, e.pathname);
    }
  };

  handleCloseTab = (tab) => {
    this.setState((state) => ({
      ...state,
      openTabs: state.openTabs.filter((t) => t.url !== tab.url),
    }));
  };

  handleToggleLauncher = () => {
    this.setState((state) => ({...state, launcherOpen: !state.launcherOpen}));
  };

  handleCloseLauncher = () => {
    this.setState((state) => ({...state, launcherOpen: false}));
  };

  handleLaunch = (tab, pathname) => {
    this.setState((state) => ({
      ...state,
      launcherOpen: false,
      openTabs: (
        state.openTabs.some((t) => t.rootUrl === tab.url)
        ? state.openTabs.map((t) => t.rootUrl === tab.url ? {...t, url: pathname} : t)
        : [...state.openTabs, {...tab, content: tab.content, rootUrl: tab.url}]
      ),
    }));
    if (!pathname) {
      this.props.history.push(tab.url);
    }
  };
}

// https://github.com/facebook/react/issues/14061
const WithRouterWorkspace = withRouter(Workspace);
export default WithRouterWorkspace;

WithRouterWorkspace.Placeholder = (props) => (
  <React.Fragment>
    <div className="ds__Workspace">
      <div className="ds__Workspace__header">
        <TabBar.Placeholder />
      </div>
      <div className="ds__Workspace__content">
        <WorkspaceContent.Placeholder />
      </div>
    </div>
  </React.Fragment>
);
